"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const ListPillsSet_vue_1 = __importDefault(require("./ListPillsSet.vue"));
const ListPill_vue_1 = __importDefault(require("./ListPill.vue"));
const FilterValue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/FilterValue"));
let OptList = class OptList extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.items = [];
    }
    mounted() {
        this.onOptionChanged();
        if (this.modelValue.type !== 'list') {
            this.emitValue();
            return;
        }
    }
    onOptionChanged() {
        this.items = this.options.map(option => ({
            option: option,
            selected: false,
        }));
    }
    toggleAll() {
        if (this.items.every(p => p.selected)) {
            this.items.forEach(p => p.selected = false);
        }
        else {
            this.items.forEach(p => p.selected = true);
        }
    }
    emitValue() {
        const items = this.items.filter(it => it.selected).map(it => it.option);
        this.$emit('update:modelValue', FilterValue_1.default.newList(items));
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], OptList.prototype, "modelValue", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], OptList.prototype, "label_fn", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], OptList.prototype, "options", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('options')
], OptList.prototype, "onOptionChanged", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('items', { deep: true })
], OptList.prototype, "emitValue", null);
OptList = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            ListPillsSet: ListPillsSet_vue_1.default, ListPill: ListPill_vue_1.default,
        }
    })
], OptList);
exports.default = OptList;
